import React, {useState, useContext} from 'react'
import {AlertContext} from '../context/alert/alertContext'
import {FirebaseContext} from '../context/firebase/firebaseContext'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
export const Form = () => {

  const [value, setValue] = useState('')
  const [valueType,setValueType] = useState('')
  const [valueHeight,setValueHeiht] = useState('')
  const [valuePrice,setValuePrice] = useState('')
  const [valueDate,setValueDate] = useState(new Date())
  const [valueBrutto,setValueBrutto] = useState('')
  const [valueNetto,setValueNetto] = useState('')
  const [valyeTare,setValueTare] = useState('')
  const alert = useContext(AlertContext)
  const firebase = useContext(FirebaseContext)
  let netto = 0;
  
  const submitHandler = event => {
    event.preventDefault()
    let brutto = valueBrutto;
    let tare = valyeTare;  
    netto = brutto - tare

    if (value.trim() && valueType && valueBrutto && valyeTare && valuePrice && valueDate) {
      firebase.addNote(value.trim(),valueType,netto,valueBrutto,valyeTare,valueDate.toLocaleString(),valuePrice).then(() => {
      
        alert.show('Успешно отправлено', 'success')
      }).catch(() => {
        alert.show('Что-то пошло не так', 'danger')
      })
      setValueType('')
      setValue('')
      setValuePrice('')
      setValueTare('')
      setValueDate('')
      setValueBrutto('')
    } else {
      alert.show('Введите данные')
    }
  }
  

  return (
    <form>
      <div className="row">

      <div className="form-group w-25 pb-2 col">
        <input
          type="text"
          className="form-control"
          placeholder="Введите название металла"
          value={value}
          onChange={e => setValue(e.target.value)} />

      </div>
      <div className="w-100"></div>

      <div className="form-group w-25 pb-2 col">
          <input
            type="text"
            className="form-control"
            placeholder="Введите вид лома"
            value={valueType}
            onChange={e => setValueType(e.target.value)} />

        </div>
        <div className="w-100"></div>
        <div className="form-group w-25 pb-2 col">
          <input
            type="text"
            className="form-control"
            placeholder="Масса брутто"
            value={valueBrutto}
            onChange={e => setValueBrutto(e.target.value)} />

        </div>
        <div className="w-100"></div>

        <div className="form-group w-25 pb-2 col ">
          <input
            type="text"
            className="form-control"
            placeholder="Масса тары"
            value={valyeTare}
            onChange={e => setValueTare(e.target.value)} />

        </div>
        <div className="w-100"></div>
        <div className="form-group w-25 pb-2 col ">
          <input
            type="text"
            className="form-control"
            placeholder="Введите цену за килограмм"
            value={valuePrice}
            onChange={e => setValuePrice(e.target.value)} />

        </div>
        <div className="w-100"></div>
        <div className="form-group w-25 pb-2 col ">
        <DatePicker
        className=" w-100 pb-2 rounded border colo"
          selected={valueDate}
          onChange={(valueDate) => setValueDate(valueDate)}
         />

        </div>
        

        <div className="form-group pb-2 col w-25">
        <button type="button" className="btn btn-primary ml-3" style={{height:38+ 'px'}} onClick={submitHandler}>Отправить</button>
        </div>
        
        </div>
    </form>
    
  )
}
